import { render, staticRenderFns } from "./BaseToggle.vue?vue&type=template&id=4446fea5&scoped=true"
import script from "./BaseToggle.vue?vue&type=script&lang=js"
export * from "./BaseToggle.vue?vue&type=script&lang=js"
import style0 from "./BaseToggle.vue?vue&type=style&index=0&id=4446fea5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4446fea5",
  null
  
)

export default component.exports